import * as React from "react";
const SvgPending = (props) => /* @__PURE__ */ React.createElement("svg", { id: "uuid-f2619d4d-5adf-466c-9e22-b2c89a1ba0ef", "data-name": "uuid-fbd6a643-e41f-4b28-bdab-0a326d2900b9", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React.createElement("path", { d: "m12,9v2.93c0,.37.11.74.3,1.06l1.84,2.95", style: {
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "square"
} }), /* @__PURE__ */ React.createElement("path", { d: "m12,20c-4.42,0-8-3.58-8-8S7.58,4,12,4c2.75,0,5.18,1.39,6.62,3.5", style: {
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round"
} }), /* @__PURE__ */ React.createElement("path", { d: "m15.5,8h3.07c.25-.01.46-.19.49-.44l.44-3.06", style: {
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round"
} }), /* @__PURE__ */ React.createElement("line", { x1: 15.49, y1: 17.95, x2: 16.52, y2: 19.69, style: {
  fill: "none",
  stroke: "currentColor",
  strokeMiterlimit: 10
} }), /* @__PURE__ */ React.createElement("line", { x1: 18.06, y1: 15.41, x2: 19.8, y2: 16.44, style: {
  fill: "none",
  stroke: "currentColor",
  strokeMiterlimit: 10
} }), /* @__PURE__ */ React.createElement("line", { x1: 19, y1: 11.9, x2: 21, y2: 11.9, style: {
  fill: "none",
  stroke: "currentColor",
  strokeMiterlimit: 10
} }));
export default SvgPending;
